import React from 'react';
import { Controller } from 'react-hook-form';
import clsx from 'clsx';

const HookFormGroupCheckbox = ({
  hookForm,
  name,
  label,
  options,
  rules = {},
}) => {
  const { control, formState } = hookForm;
  const error = formState.errors[name];

  return (
    <>
      <style>{`
        .checkbox-grid {
          display: flex;
          flex-wrap: wrap;
          margin-top: 1rem;
        }

        .checkbox-column {
          width: 100%;
          padding-right: 1rem;
        }

        @media (min-width: 640px) {
          .checkbox-column {
            width: 50%;
          }
        }

        @media (min-width: 768px) {
          .checkbox-column {
            width: 33.3333%;
          }
        }

        @media (min-width: 1024px) {
          .checkbox-column {
            width: 20%;
          }
        }

        .checkbox-item {
          display: flex;
          align-items: flex-start;
          gap: 0.5rem;
          margin-bottom: 1rem;
        }
      `}</style>

      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => {
          return (
            <div className="nsw-form__group">
              <fieldset className="nsw-form__fieldset">
                <legend className="nsw-form__legend">{label}</legend>

                <div className="checkbox-grid">
                  {options.map((option) => {
                    const isChecked = field.value?.includes(option.value);

                    return (
                      <div key={option.value} className="checkbox-column">
                        <div className="checkbox-item">
                          <input
                            type="checkbox"
                            className="nsw-form__checkbox-input mt-1"
                            id={`${name}-${option.value}`}
                            checked={isChecked}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              let newValue = [...(field.value || [])];

                              if (checked) {
                                newValue.push(option.value);
                              } else {
                                newValue = newValue.filter(
                                  (val) => val !== option.value
                                );
                              }

                              field.onChange(newValue);
                            }}
                          />
                          <label
                            className={clsx('nsw-form__checkbox-label')}
                            htmlFor={`${name}-${option.value}`}
                          >
                            {option.text}
                          </label>
                        </div>
                      </div>
                    );
                  })}
                </div>

                {error && (
                  <span className="tw-text-sm tw-text-red-600 mt-2 block">
                    {error.message}
                  </span>
                )}
              </fieldset>
            </div>
          );
        }}
      />
    </>
  );
};

export default HookFormGroupCheckbox;
